export default __webpack_public_path__ + "static/images/lisa_01.png";